import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { CustomerCategory, ListResponse } from '@/types';
import { Pagination } from '@/components';
import { EditFlat, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteCustomerCategory, UpdateCustomerCategory } from '../components';

export interface CustomerCategoryListProps {
  list?: ListResponse<CustomerCategory>;
  page: number;
  onChangePage(page: number): void;
}

const CustomerCategoriesTable: React.FC<CustomerCategoryListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentCustomerCategory, setCurrentCustomerCategory] = useState<CustomerCategory | null>(null);

  function openUpdateModal(customerCategory: CustomerCategory) {
    setCurrentCustomerCategory(customerCategory);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(customerCategory: CustomerCategory) {
    setCurrentCustomerCategory(customerCategory);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Наименование</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((customerCategory) => {
                const { name, id } = customerCategory;

                return (
                  <TableRow key={id}>
                    <TableCell>{name}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(customerCategory)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(customerCategory)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateCustomerCategory
        customerCategory={currentCustomerCategory!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteCustomerCategory
        customerCategory={currentCustomerCategory!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default CustomerCategoriesTable;
